// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"dba77996","453":"258b012d","777":"f594d0ad"}[chunkId] + ".chunk.js";
};